import { createContentPropTypes } from '../../../helpers/content';

const content = {
	confirmButton: 'Check now',
	cancelButtonText: 'Cancel',
	continueButtonText: 'Continue',
	retryButtonText: 'Try again',
	title: 'Let’s make a match',
	body: '<p>We’re about to ask their bank if the name on the account matches what you’ve entered.</p><p>Getting a match can help you decide if you’re paying the right account.</p>',
	nameEnteredLabel: 'Name entered',
	nameMatchedLable: 'Name on matching account',
	accountEnteredLabel: 'Account chosen',
	accountMatchedLabel: 'Matching Account',
	updateButtonText: 'Update with matching details',
	keepButtonText: 'Keep as is',
	editButtonText: 'Edit details',
	blockedHeading: 'Nothing to match',
	blockedHeaderDetail:
		'We can’t connect to the name-matching service right now. If you keep these details, you can try again later before you make a payment.',
	blockedFooter: 'Keep or cancel?',
	blockedFooterDetailBusiness:
		'The account might be right, but you should double check with the business you’d like to pay if you’re not sure.',
	blockedFooterDetailPersonal:
		'The account might be right, but you should double check with the person you’d like to pay if you’re not sure.',
	accountWarningHeader: 'Check you have the right account',
	accountWarningDetailsBusiness:
		'Before you continue, please make sure you have the right account by double checking the details with the business you’d like to pay. It’s unlikely you’ll get your money back if it goes to the wrong account or a fraudster.',
	accountWarningDetailsPersonal:
		'Before you continue, please make sure you have the right account by double checking the details with the person you’d like to pay. It’s unlikely you’ll get your money back if it goes to the wrong account or a fraudster.',
	serviceDownHeading: 'Nothing to match',
	serviceDownHeaderDetail: 'We can’t connect to the name-matching service right now.',
	serviceDownFooter: 'Try again or edit these details? ',
	serviceDownFooterDetailBusiness:
		'The account might be right, but you should double check with the business you’d like to pay if you’re not sure.',
	serviceDownFooterDetailPersonal:
		'The account might be right, but you should double check with the person you’d like to pay if you’re not sure.',
	matchMadeText: 'Match made',
	matchMadeAndSavedText: 'Match made and saved',
	refEnteredLabel: 'Reference entered',
	genericErrorHeader: 'Error',
	genericErrorFooter: 'Return to previous page',
	createTemplateDuplicateError:
		'Sorry, a template’s already been set up with this name. Please choose another name then try again.',
	okButtonText: 'OK',
	accountWarningHeader: 'Check you have the right account',
	match_made_heading: 'We’ve made a match',
	match_made_header_detail: 'We’ve been able to successfully match the payee details to an account.',
	loadingHeader: 'We’re checking for a match',
};

export default content;
export const contentPropTypes = createContentPropTypes(content);
